import { ViewController } from 'ionic-angular/navigation/view-controller';
import { HareketdetayPage } from './../../CariIslemleri/hareketdetay/hareketdetay';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the StokHareketDetayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-stok-hareket-detay',
  templateUrl: 'stok-hareket-detay.html',
})
export class StokHareketDetayPage {
  vwHareket:any={};
  hareketdetaylar=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("vwHareket") != null) {
        this.vwHareket = navParams.get("vwHareket");
        console.log("b",this.vwHareket)
        var data=new FormData();
        data.append("hareketid_json",this.vwHareket.ID);
        this.bllOrtak.islem(data,"StokHareketDetay","",false).then(a=>{
          var sonuc=<any>a;
          this.hareketdetaylar=sonuc.SonucObject;
          console.log("a",this.hareketdetaylar)
      })
    }
  }

  ionViewDidLoad() {

  }
  kapat(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stok-hareket-detay/stok-hareket-detay.ts